import ColumnChartWrapper from './ColumnChartWrapper.container';

export default ColumnChartWrapper;
